var obj = {
    version: 1.0,
    device: 'web',
    apiSuccess: 200,
    apiError: 202,
    apiForcefullyLogout: 203,
    somethingWentWrong: "Something went wrong, please try again!"
};

export default obj;